<template>
  <WidgetCard
    title="URLs with most alerts by severity"
    icon="warning"
    :loading="loading"
    :error="error"
    :empty="emptyMessage"
  >
    <template #headerExtra>
      <a-radio-group :value="days" @change="onChangeWindow">
        <a-radio-button :value="1">
          1D
        </a-radio-button>
        <a-radio-button :value="3">
          3D
        </a-radio-button>
        <a-radio-button :value="7">
          7D
        </a-radio-button>
        <a-radio-button :value="14">
          14D
        </a-radio-button>
        <a-radio-button :value="30">
          30D
        </a-radio-button>
      </a-radio-group>
    </template>
    <template #toolbar>
      <div class="dw-rank-toolbar">
        <div class="dw-sevtoggles">
          <span class="dw-sevtoggles__label">Filter by severity:</span>
          <span
            v-for="s in severities"
            :key="s.key"
            class="dw-sevtoggle"
            :class="{ 'is-off': !visible[s.key] }"
            @click="toggle(s.key)"
          >
            <span class="dw-sevtoggle__dot" :style="{ background: s.color }" />
            {{ s.label }}
          </span>
        </div>
      </div>
    </template>
    <template v-if="ready">
      <div class="dw-rank">
        <div v-for="row in pages" :key="row.id" class="dw-rank__row">
          <router-link
            class="dw-rank__name"
            :to="{ path: '/incident/list', query: { search: row.url || row.name } }"
            :title="row.url || row.name"
          >{{ row.url || row.name }}</router-link>
          <span class="dw-rank__count">
            <template v-for="(s, idx) in activeSeverities">
              <span v-if="idx > 0" :key="s.key + '-sep'"> · </span>
              <span :key="s.key" :style="{ color: s.color, fontWeight: 600 }">{{ row[s.key] }} {{ s.short }}</span>
            </template>
          </span>
          <span class="dw-rank__bar">
            <span class="dw-rank__stack">
              <span
                v-for="s in activeSeverities"
                :key="s.key"
                :style="{ width: segWidth(row[s.key]), background: s.color }"
              />
            </span>
          </span>
        </div>
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';
  import dashboardFilters from '../../mixins/dashboardFilters.mixin';

  const SEVERITIES = [
    { key: 'high', level: 'HIGH', label: 'HIGH', short: 'high', color: '#FF5A00' },
    { key: 'medium', level: 'MEDIUM', label: 'MED', short: 'med', color: '#f5c518' },
    { key: 'low', level: 'LOW', label: 'LOW', short: 'low', color: '#1e88e5' }
  ];

  export default {
    name: 'TopPagesWidget',
    components: { WidgetCard },
    mixins: [dashboardWidget, dashboardFilters],
    data() {
      return {
        days: 7,
        severities: SEVERITIES,
        visible: { high: true, medium: true, low: true },
        pages: []
      };
    },
    computed: {
      activeSeverities() {
        return this.severities.filter((s) => this.visible[s.key]);
      },
      levels() {
        return this.activeSeverities.map((s) => s.level);
      },
      ready() {
        return !this.loading && !this.error && this.pages.length > 0;
      },
      emptyMessage() {
        if (this.loading || this.error || this.pages.length > 0) return '';
        if (!this.levels.length) return 'Select a severity to view';
        return 'No incidents in this period';
      },
      max() {
        return (
          this.pages.reduce((m, r) => {
            const total = this.activeSeverities.reduce((sum, s) => sum + (r[s.key] || 0), 0);
            return Math.max(m, total);
          }, 0) || 1
        );
      }
    },
    methods: {
      // Empty when no severity selected (fetchData short-circuits too).
      cacheDescriptors() {
        if (!this.levels.length) return [];
        return [DashboardService.resources.topPages(this.days, this.tagIds, this.planTypes, this.levels)];
      },
      segWidth(n) {
        return `${((n || 0) / this.max) * 100}%`;
      },
      onChangeWindow(e) {
        this.days = e.target.value;
        this.fetchData();
      },
      toggle(key) {
        this.visible = { ...this.visible, [key]: !this.visible[key] };
        this.fetchData();
      },
      // No severity selected — settle empty rather than asking for nothing.
      fetchResource() {
        if (!this.levels.length) return { pages: [] };
        return DashboardService.fetchTopPagesBySeverity(
          this.days,
          this.tagIds,
          this.planTypes,
          this.levels
        );
      },
      applyResult(res) {
        this.pages = res.pages;
      }
    }
  };
</script>
